module.exports = __webpack_public_path__ + "static/popup_PC@2x-min-c2ac6a414ee73968c6f14f2c8488b888.webp";